import { inject, observer } from "mobx-react";

import { getDepositCheck, analyticeEvent, posOrderCallType } from "utils/Utils";
import { fn_bridge_print, fn_bridge_pos_order_call, fn_bridge_pos_order_cook } from "function/FnPosBridge";
import { fn_print_receipt, fn_show_accept_order_reject } from "function/FnBodyStep";
import { fn_pos_order_complete_layer } from "function/FnBodyLayer";
import { MobileOrderFg, StepCd } from "types";

const PosOrderDetailButton = ({ rootStore, order, type }) => {
  const searchStore = rootStore.searchStore;
  const printerSetting = rootStore.settingStore.getPrinterInfo;

  let printFormCheck = false;
  let disableState = false;
  let disableStateN2 = false;
  let disableStateN3 = false;
  let disableStateN4 = false;
  let detailType = "";
  const callType = posOrderCallType(rootStore, order);

  if (
    (searchStore.getCurrStepType === "all" && order.stepType === "READY") ||
    searchStore.getCurrStepType === "ready"
  ) {
    detailType = "ready";
  } else if (
    (searchStore.getCurrStepType === "all" && order.stepType === "COOKING") ||
    searchStore.getCurrStepType === "cooking"
  ) {
    detailType = "cooking";
  } else if (
    (searchStore.getCurrStepType === "all" && order.stepType === "DELIVERY") ||
    searchStore.getCurrStepType === "delivery"
  ) {
    if ((order.dlvStatusFg === null || order.dlvStatusFg === "99") && order.stepCd === "500") {
      detailType = "cooking";
    } else {
      detailType = "delivery";
    }
  } else if (searchStore.getCurrStepType === "end") {
    detailType = "end";
  }
  if (type === "end") {
    detailType = "end";
  }

  if (type === "end" && rootStore.searchStore.getShopCdSaleDate.saleDate != order.saleDate) {
    disableState = true;
  }

  if (printerSetting.kitchenPrinterSettings.length > 0) {
    printFormCheck = true;
  } else {
    if (
      (order.mobileOrderFg === "18" && order.morderTypeCd === "O") ||
      order.mobileOrderFg === "00" ||
      order.mobileOrderFg === "24" ||
      order.mobileOrderFg === "37"
    ) {
      disableState = true;
    }
  }

  let depositCk = getDepositCheck(order);

  if (
    detailType === "delivery" &&
    order.orderType === "DELIVERY" &&
    !(!order.dlvStatusFg || order.dlvStatusFg === "00")
  ) {
    disableStateN2 = true;
  }
  if (!(detailType === "ready" || detailType === "cooking" || detailType === "delivery")) {
    disableStateN2 = true;
  }
  if (detailType === "end") {
    if (order.stepCd === "700") {
      disableStateN2 = false;
    } else {
      disableStateN2 = true;
    }
  }
  if (
    detailType === "cooking" &&
    order.orderType === "PICKUP" &&
    order.partnerType === "CID" &&
    order.payType === "PAID" &&
    depositCk === true
  ) {
    disableStateN3 = true;
  }
  if (order.saleDate != rootStore.searchStore.getSaleDate && order.stepCd === "700") {
    disableStateN4 = true;
  }

  function onClickActionBtn(typeNumber) {
    if (typeNumber === 1) {
      if (order.mobileOrderFg === MobileOrderFg.KIOSK && order.morderTypeCd === "P") {
        fn_print_receipt(rootStore, order.mobileOrderNo, printFormCheck);
      } else {
        fn_bridge_print(rootStore, "1");
      }
    } else if (typeNumber === 2) {
      fn_show_accept_order_reject(
        rootStore,
        order.mobileOrderNo,
        `${order.stepCd === StepCd.ORDER_COMPLETED ? "kdsOrderCancelOldDetail" : "kdsOrderCancelDetail"} Button`
      );
    } else if (typeNumber === 3) {
      if (callType) {
        if (order.stepCd === StepCd.ACCEPTED) {
          analyticeEvent("kdsOrderComplete", "kdsOrderCompleteDetail Button", "Button");
          fn_pos_order_complete_layer(rootStore, order);
        } else if (order.stepCd === StepCd.PICKUP_REQUEST) {
          //재호출
          analyticeEvent("kdsPickupRecall", "kdsPickupRecallDetail Button", "Button");
          fn_bridge_pos_order_call(rootStore, order, "", callType);
          return null;
        }
      } else {
        if (order.stepCd === StepCd.ACCEPTED || order.stepCd === StepCd.PICKUP_REQUEST) {
          analyticeEvent("kdsOrderComplete", "kdsOrderCompleteDetail Button", "Button");
          fn_pos_order_complete_layer(rootStore, order);
        }
      }
    } else if (typeNumber === 4) {
      if (order.stepCd === StepCd.ORDER_COMPLETED) {
        analyticeEvent("kdsBacktoCooking", "kdsBacktoCookingDetail Button", "Button");
        fn_bridge_pos_order_cook(rootStore, order);
        return;
      }
      if (callType) {
        if (order.stepCd === StepCd.ACCEPTED) {
          analyticeEvent("kdsPickupCall", "kdsPickupCallDetail Button", "Button");
          fn_bridge_pos_order_call(rootStore, order, "", callType);
        } else if (order.stepCd === StepCd.PICKUP_REQUEST) {
          analyticeEvent("kdsOrderComplete", "kdsOrderCompleteDetail Button", "Button");
          fn_pos_order_complete_layer(rootStore, order);
        } else if (order.stepCd === StepCd.ORDER_COMPLETED) {
          analyticeEvent("kdsBacktoCooking", "kdsBacktoCookingDetail Button", "Button");
          fn_bridge_pos_order_cook(rootStore, order);
        }
      }
    }
  }

  const buttonRenderRules = [
    // --- 버튼 1 ---
    {
      condition: ({ typeNumber, order }) =>
        typeNumber === 1 && order.mobileOrderFg === MobileOrderFg.KIOSK && order.morderTypeCd === "P",
      content: <span className="txt">재출력</span>,
    },
    {
      condition: ({ typeNumber }) => typeNumber === 1,
      content: <span className="txt">주방재출력</span>,
    },

    // --- 버튼 2 ---
    {
      condition: ({ typeNumber }) => typeNumber === 2,
      content: <span className="txt">주문취소</span>,
    },

    // --- 버튼 3 ---
    {
      condition: ({ typeNumber, order, callType }) =>
        typeNumber === 3 && !!callType && order.stepCd === StepCd.ACCEPTED,
      content: <span className="txt">완료처리</span>,
    },
    {
      condition: ({ typeNumber, order, callType }) =>
        typeNumber === 3 && !!callType && order.stepCd === StepCd.PICKUP_REQUEST,
      content: <span className="txt">재호출</span>,
    },
    {
      condition: ({ typeNumber, order, callType }) =>
        typeNumber === 3 && !callType && (order.stepCd === StepCd.ACCEPTED || order.stepCd === StepCd.PICKUP_REQUEST),
      content: <span className="txt">픽업완료</span>,
    },

    // --- 버튼 4 ---
    {
      condition: ({ typeNumber, order, callType }) =>
        typeNumber === 4 && !!callType && order.stepCd === StepCd.ACCEPTED,
      content: (
        <div className="flex flex-col">
          <span className="txt">호출</span>
          <span className="more">(픽업요청 알림발송)</span>
        </div>
      ),
    },
    {
      condition: ({ typeNumber, order, callType }) =>
        typeNumber === 4 && !!callType && order.stepCd === StepCd.PICKUP_REQUEST,
      content: <span className="txt">픽업완료</span>,
    },
    {
      condition: ({ typeNumber, order }) => typeNumber === 4 && order.stepCd === StepCd.ORDER_COMPLETED,
      content: <span className="txt">조리중으로 이동</span>,
    },
  ];

  function btnTypeTxt(typeNumber) {
    if (!typeNumber) return null;
    const foundRule = buttonRenderRules.find(rule => rule.condition({ typeNumber, order, callType }));
    return foundRule ? foundRule.content : null;
  }
  const rendering = () => {
    const buttonConfigs = [
      { id: 1, disabled: disableState },
      { id: 2, disabled: disableStateN2 },
      { id: 3, disabled: disableStateN3 },
      { id: 4, disabled: disableStateN4 },
    ];
    return buttonConfigs
      .map(config => ({
        ...config,
        content: btnTypeTxt(config.id),
      }))
      .filter(button => button.content !== null)
      .map(button => {
        return (
          <li key={button.id}>
            <button
              type="button"
              onClick={() => onClickActionBtn(button.id)}
              className={"btn btn_type" + button.id}
              disabled={button.disabled || false}
            >
              {button.content}
            </button>
          </li>
        );
      });
  };

  /// 조건 끝
  return (
    <div className="section_btn">
      <ul>{rendering()}</ul>
    </div>
  );
};

export default inject("rootStore")(observer(PosOrderDetailButton));
